import { RadixDialog } from '@/components/RadixDialog';
import CloseSvgIcon from '@/public/images/icons/close_icon.svg';
import styled, { css } from 'styled-components';

export const PopupContainer = styled.div<{ hasHeroImage: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;

  ${({ hasHeroImage }) =>
    !hasHeroImage &&
    css`
      bottom: unset;
      left: unset;
      border-radius: 8px;
      height: auto;
      overflow: hidden;
      max-width: 355px;
  `}

  ${({ theme }) => theme.mediaBreakpointUp.lg} {
    bottom: unset;
    left: unset;
    border-radius: 8px;
    height: auto;
    flex-direction: row-reverse;
    overflow: hidden;
    max-width: ${({ hasHeroImage }) => (hasHeroImage ? 781 : 493)}px;
  }
`;

export const CloseIcon = styled(CloseSvgIcon).attrs({ width: 28, height: 28 })(({ theme }) => ({
  cursor: 'pointer',
  backgroundColor: theme.colors.highEmphasisWhite,
  borderRadius: 4,
  padding: theme.spacing[4],

  path: {
    fill: theme.colors.mediumEmphasisBlack,
  },

  [`${theme.mediaBreakpointUp.lg}`]: {
    display: 'block',
  },
}));

export const CloseIconWrapper = styled(RadixDialog.Close)<{ hasHeroImage: boolean }>(({ hasHeroImage, theme }) => ({
  position: 'absolute',
  top: 12,
  right: 12,
  display: hasHeroImage ? 'none' : 'flex',
  width: 'fit-content',
  height: 'fit-content',
  border: 'none',
  background: 'none',
  padding: 0,
  margin: 0,
  cursor: 'pointer',

  [`${theme.mediaBreakpointUp.lg}`]: {
    display: 'flex',
  },
}));
